import { render, staticRenderFns } from "./LandingAssessment.vue?vue&type=template&id=b1a86940&scoped=true&"
import script from "./LandingAssessment.vue?vue&type=script&lang=js&"
export * from "./LandingAssessment.vue?vue&type=script&lang=js&"
import style0 from "./LandingAssessment.vue?vue&type=style&index=0&id=b1a86940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a86940",
  null
  
)

export default component.exports